export { default } from './HeroHeaderComponent';
